import Cookies from 'js-cookie';
import { parseDomain } from "parse-domain";

import { bannerWillOpen } from '../modules/banner-marketing';

document.addEventListener('alpine:init', () => {
  Alpine.data('videoPopup', () => ({
    isOpen: false,
    canOpen: false,
    init() {
      this.canOpen = !this.isDismissed() && !this.hasOtherPopup();

      if (this.canOpen) {
        this.watchForOtherPopup();
      }
    },
    handleScroll() {
      const scrollPosition = window.scrollY || window.pageYOffset;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollPosition > (documentHeight - windowHeight) / 2) {
        this.showPopUp();
      }
    },
    watchForOtherPopup() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            const hasPopUp = document.body.classList.contains('has-pop-up');
            if (hasPopUp) {
              this.canOpen = false;
            }
          }
        });
      });

      observer.observe(document.body, { attributes: true });
    },
    hasOtherPopup() {
      return bannerWillOpen() || document.body.classList.contains('has-pop-up');
    },
    showPopUp() {
      if (this.canOpen) {
        this.isOpen = true;
      }
    },
    isDismissed() {
      return Boolean(sessionStorage.getItem(`hide-video-pop-up`));
    },
    setIsDismissed(value = true) {
      return sessionStorage.setItem(`hide-video-pop-up`, value ? 1 : 0);
    },
    closePopup() {
      this.setIsDismissed(true);
      this.canOpen = false;
      this.isOpen = false;
    },
    setCookie() {
      const { hostname } = new URL(window.location.href);
      const parsed = parseDomain(hostname);

      Cookies.set('previousUrl', window.location.href, { domain: `${parsed.domain}.${parsed.topLevelDomains?.join('.')}`});
    },
  }))
}
);

